export default __webpack_public_path__ + "static/media/mercedes.5ce1bfcb.png";